import React from 'react';
import './Blog.css';

const blogPosts = [
  {
    title: 'Panduan Membuat Website UMKM yang Dapat Menghasilkan Leads',
    category: 'Website Development',
    excerpt:
      'Artikel ini akan menjadi tempat untuk membagikan strategi pembuatan website yang fokus pada konversi, pengalaman pengguna, dan hasil nyata untuk bisnis lokal.',
    readTime: '5 menit baca',
    status: 'Siap diisi'
  },
  {
    title: 'Kenapa SEO Tetap Penting untuk Bisnis Lokal di Tahun 2026',
    category: 'SEO',
    excerpt:
      'Gunakan kartu ini untuk mempublikasikan insight SEO, trik optimasi, dan kasus penggunaan yang membantu audiens memahami nilai solusi digital Anda.',
    readTime: '4 menit baca',
    status: 'Siap diisi'
  },
  {
    title: 'Strategi Konten untuk Meningkatkan Traffic dan Kredibilitas Brand',
    category: 'Content Strategy',
    excerpt:
      'Tempat ini bisa kamu isi dengan artikel edukasi, tips, studi kasus, atau update layanan agar pengunjung lebih sering kembali ke situs Anda.',
    readTime: '6 menit baca',
    status: 'Siap diisi'
  }
];

function Blog() {
  return (
    <div className="blog-page">
      <section className="blog-hero">
        <div className="blog-hero__content">
          <p className="blog-hero__eyebrow">Artikel & Blog</p>
          <h1 className="blog-hero__title">Tempat artikel dan insight untuk brand Cakra Digital Innovation</h1>
          <p className="blog-hero__description">
            Halaman ini sudah disiapkan sebagai ruang publikasi untuk artikel, tutorial, studi kasus, dan update terbaru tentang layanan digital.
          </p>
          <div className="blog-hero__actions">
            <a href="#blog-posts" className="blog-btn blog-btn--primary">
              Lihat daftar artikel
            </a>
            <a href="/consultation" className="blog-btn blog-btn--secondary">
              Minta konsultasi konten
            </a>
          </div>
        </div>
        <div className="blog-hero__panel">
          <div className="blog-hero__panel-card">
            <p className="blog-hero__panel-label">Siap dipakai</p>
            <h2>Artikel kamu bisa ditambahkan dengan mudah</h2>
            <ul>
              <li>Tambah judul, kategori, dan ringkasan</li>
              <li>Tampilkan gambar atau thumbnail</li>
              <li>Publikasikan artikel baru tanpa mengubah struktur halaman</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="blog-guide">
        <div className="blog-guide__card">
          <p className="blog-guide__label">Cara menggunakan halaman ini</p>
          <h2>Masukkan konten blog kamu di sini</h2>
          <p>
            Kamu bisa mengganti data artikel pada file <strong>client/src/Blog.js</strong> agar sesuai dengan tulisan, kategori, dan jadwal publikasi yang kamu inginkan.
          </p>
        </div>
        <div className="blog-guide__card">
          <p className="blog-guide__label">Yang sudah tersedia</p>
          <ul>
            <li>Hero section untuk branding artikel</li>
            <li>Kartu artikel dengan ringkasan</li>
            <li>Area untuk kategori dan CTA</li>
            <li>Struktur yang mudah dikembangkan menjadi halaman detail per artikel</li>
          </ul>
        </div>
      </section>

      <section id="blog-posts" className="blog-posts">
        <div className="blog-posts__header">
          <div>
            <p className="blog-posts__eyebrow">Draft & placeholder</p>
            <h2>Artikel siap kamu isi</h2>
          </div>
          <p className="blog-posts__description">
            Gunakan contoh ini sebagai kerangka awal. Kamu bisa menambah, menghapus, atau mengganti artikel kapan saja.
          </p>
        </div>

        <div className="blog-posts__grid">
          {blogPosts.map((post) => (
            <article key={post.title} className="blog-card">
              <p className="blog-card__category">{post.category}</p>
              <h3>{post.title}</h3>
              <p>{post.excerpt}</p>
              <div className="blog-card__meta">
                <span>{post.readTime}</span>
                <span>{post.status}</span>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Blog;
